var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PreferencesService } from '../../services/preferences.service';
import { CommunicationService } from '../../services/communication.service';
import { HasSubscriptions } from '../has-subscriptions';
import { GoogleMapsService } from '../../services/google-maps.service';
import { InputComponent } from '../forms/input/input.component';
import { FormBuilder } from '@angular/forms';
import { ListingsService } from '../../services/listings.service';
import { UserPreferences } from '../../classes/user-preferences';
import { Pagination } from '../../classes/pagination';
import { combineLatest } from 'rxjs';
import { ADD_SAVED_LISTING_PREVIEW_GTM, SITE_SEARCH, SITE_SEARCH_TERM } from '../../classes/analytics-tags';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { Helper } from '../../classes/helper';
import { ChangeDetectorRef } from '@angular/core';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { NgZone } from '@angular/core';
var SearchBarComponent = /** @class */ (function (_super) {
    __extends(SearchBarComponent, _super);
    function SearchBarComponent(document, _communicationService, _preferencesService, _listingService, _googleService, _router, _formBuilder, cdRef, analyticsService, zone) {
        var _this = _super.call(this) || this;
        _this.document = document;
        _this._communicationService = _communicationService;
        _this._preferencesService = _preferencesService;
        _this._listingService = _listingService;
        _this._googleService = _googleService;
        _this._router = _router;
        _this._formBuilder = _formBuilder;
        _this.cdRef = cdRef;
        _this.analyticsService = analyticsService;
        _this.zone = zone;
        _this.showBackButton = false; // Show the option to go to the previous page (mobile only)
        _this.showResultsOnInit = false; // Whether to automatically show results when the component is loaded
        _this.showAdditionalActionsButtons = false; // Show the near me and saved searches button
        _this.shouldShowFiltersAfterSearching = false; // Whether it should continue to the filters page after searching, only true for mobile
        _this.isNearMe = false;
        _this.canHideSearchResults = true; // Option as to whether or not we always display the search results
        _this.focus = false;
        _this.rightPositionedIcon = false; // Whether the magnifier glass is right positioned
        _this.placeholder = '';
        _this.updatePlaceholder = true;
        _this.searchIcon = '/assets/icons/filters/Search_icon@1x.svg';
        _this.showSearchResults = false;
        _this.locationResults = [];
        _this.mlsMatchResults = [];
        _this.recentSearches = [];
        _this.isSearching = false;
        _this._radiusForSearchBias = 50000; // in meters
        _this._maxLocationResults = 3;
        _this._favouriteListings = [];
        _this.searchForm = _this._formBuilder.group({ searchInput: '' });
        return _this;
    }
    // Deal with the user clicking outside of the component
    SearchBarComponent.prototype.onLoseFocus = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.canHideSearchResults && !_this.searchBarRef.nativeElement.contains(_this.document.activeElement))
                _this.showSearchResults = false;
        });
    };
    SearchBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.searchForm.get('searchInput').valueChanges
            .pipe(debounceTime(200))
            .pipe(filter(function (searchInput) {
            if (!searchInput || !_this.locationLatLng) {
                _this._resetResults();
                return false;
            }
            return true;
        }))
            .pipe(switchMap(function (searchInput) { return _this._getQueryPredictionsSearch(searchInput); }))
            .subscribe(function (s) { return _this._handleQueryPredictions(s.search, s.listings, s.predictions); }));
        this.addSub(this._preferencesService.favouriteListingsChanged.subscribe(function (s) { return _this._favouriteListings = s; }));
        this.addSub(this._preferencesService.recentSearchesChanged.subscribe(function (recentSearches) { return _this.recentSearches = recentSearches.map(function (r) { return new SearchResult(r, r, 'recentSearch'); }); }));
        this.addSub(this._preferencesService.positionInfoChanged.subscribe(function (position) {
            if (position.centerLatLng) {
                _this.locationLatLng = {
                    lat: position.centerLatLng.lat,
                    lng: position.centerLatLng.lng
                };
            }
        }));
        this.addSub(this._communicationService.searching.activeSearchText.subscribe(function (text) {
            if (_this.updatePlaceholder)
                _this.placeholder = text;
        }));
    };
    SearchBarComponent.prototype.ngOnChanges = function (changes) {
        this.showSearchResults = this.showResultsOnInit;
    };
    SearchBarComponent.prototype.onSearchInputClick = function ($event) {
        if (SearchBarComponent.hasCompletedASearchRequest)
            this.searchInput = '';
        else
            this._getQueryPredictions();
        this.showSearchResults = true;
    };
    SearchBarComponent.prototype.onGoToPreviousScreenClick = function ($event) {
        this._communicationService.navigation.showSearch.next(false);
    };
    SearchBarComponent.prototype.onClearInput = function ($event) {
        this.searchInput = '';
        this._resetResults();
        this.inputComponent.inputRef.nativeElement.focus();
    };
    SearchBarComponent.prototype.onSubmit = function () {
        this.focus = false;
        this._searchForLocation();
    };
    /**
     * Select any of the results in the list
     * @param $event
     */
    SearchBarComponent.prototype.onSelectResult = function ($event) {
        if (['location', 'recentSearch'].indexOf($event.type) >= 0) {
            this.searchForm.controls.searchInput.setValue($event.text, { emitEvent: false });
            this._searchForLocation();
        }
        else if ($event.type.indexOf('mls') >= 0) {
            this._router.navigate([$event.data.detailUrl]);
            this.showSearchResults = false;
        }
        this.focus = false;
        // Search input field loses the focus when the result is selected
        this._communicationService.searching.activeSearchText.next($event.text);
    };
    SearchBarComponent.prototype.onFavouriteClick = function (listing) {
        this._preferencesService.toggleFavouriteListing(listing.listingId, ADD_SAVED_LISTING_PREVIEW_GTM);
        listing.getFavouriteIconToUse();
    };
    SearchBarComponent.prototype._resetResults = function () {
        this.mlsMatchResults = [];
        this.locationResults = [];
    };
    SearchBarComponent.prototype._updateMapWithNewPosition = function (place) {
        if (!place.geometry) {
            this._resetResults();
            return;
        }
        var position = this._preferencesService.getPosition();
        var bounds = place.geometry.bounds;
        position.zoomLevel = Helper.getZoomLevel(place.types);
        position.centerLatLng = place.geometry.location.toJSON();
        // We wont have bounds for an exact address
        position.zoomLevel = Helper.getZoomLevel(place.types);
        position.centerLatLng = place.geometry.location.toJSON();
        // We wont have bounds for an exact address
        if (bounds) {
            position.north = bounds.getNorthEast().lat();
            position.east = bounds.getNorthEast().lng();
            position.south = bounds.getSouthWest().lat();
            position.west = bounds.getSouthWest().lng();
            this._preferencesService.setPosition(position.centerLatLng.lat, position.centerLatLng.lng, position.zoomLevel, bounds.getSouthWest().lat(), bounds.getSouthWest().lng(), bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
        }
        else {
            this._preferencesService.setPosition(position.centerLatLng.lat, position.centerLatLng.lng, position.zoomLevel);
        }
        // console.log('update map with new position');
        // this._preferencesService.saveUserPosition(position);
        this._communicationService.searching.shouldCenterAtUserLocation.next(false);
        this._communicationService.searching.updateMap.next({ location: place.geometry.location.toJSON(), types: place.types, isSearchForLocation: true });
    };
    /**
     * Makes a call to the google API to find the lat,lng coordinates based on a string input
     * Updates the map with the new position if one is found
    */
    SearchBarComponent.prototype._searchForLocation = function () {
        var _this = this;
        if (this.searchInput) {
            // TODO: have to fix zoom level
            this._preferencesService.addRecentSearch(this.searchInput);
            this._googleService.performGeocode(this.searchInput).then(function (results) {
                var isQuebec = results.some(function (r) { return r.address_components && r.address_components.some(function (c) { return 'quebec' === c.long_name.toLowerCase(); }); });
                if (isQuebec) {
                    _this.shouldShowFiltersAfterSearching = false;
                    _this._communicationService.navigation.showSearch.next(false);
                    _this._communicationService.notifications.showQuebecModal.next(true);
                    results = null;
                }
                if (results) {
                    // Just use the first result if many are given
                    _this._updateMapWithNewPosition(results[0]);
                }
                _this.showSearchResults = false;
                if (_this.updatePlaceholder) {
                    _this.placeholder = _this.searchInput;
                }
                _this._communicationService.searching.activeSearchText.next(_this.searchInput);
                _this.searchInput = ''; // Reset the search input since we'ved already went to look for the location
                SearchBarComponent.hasCompletedASearchRequest = true;
                if (_this.shouldShowFiltersAfterSearching)
                    _this._communicationService.toolbar.filtersRequested.next();
                else if (!isQuebec) {
                    _this.zone.run(function () {
                        // If they're on desktop, ensure we always move to the map after they select a result
                        _this._router.navigate(['/find-real-estate']);
                    });
                }
            });
        }
    };
    SearchBarComponent.prototype._getQueryPredictions = function () {
        var _this = this;
        if (!!this.searchInput && !!this.locationLatLng) {
            this._getQueryPredictionsSearch(this.searchInput).toPromise().then(function (r) { return _this._handleQueryPredictions(r.search, r.listings, r.predictions); });
        }
        else
            this._resetResults();
    };
    SearchBarComponent.prototype._getQueryPredictionsSearch = function (searchInput) {
        this.isSearching = true;
        this.analyticsService.eventTrack(SITE_SEARCH, (_a = {}, _a[SITE_SEARCH_TERM] = searchInput, _a));
        return combineLatest(this._listingService.searchListings(searchInput, new Pagination(0, 10)), this._googleService.getPlacePredictions(searchInput, new google.maps.LatLng(this.locationLatLng.lat, this.locationLatLng.lng), this._radiusForSearchBias), function (listings, predictions) { return ({ search: searchInput, listings: listings, predictions: predictions }); });
        var _a;
    };
    /**
     * Makes a call to the following to get results:
     * 1: Google Search API
     * 2: Listing Services to find Listings by MLS ID
    */
    SearchBarComponent.prototype._handleQueryPredictions = function (searchInput, listings, predictionList) {
        var _this = this;
        if (listings !== null && listings.results !== null && listings.results.length >= 0) {
            this.mlsMatchResults = listings.results
                .filter(function (l) { return l.mlsNum && l.mlsNum.toLowerCase() === searchInput.toLowerCase(); })
                .map(function (l) {
                l.isFavourite = UserPreferences.containsFavouriteListings(_this._favouriteListings, [l.listingId]);
                return new SearchResult(l.mlsNum, l, 'mls');
            });
        }
        if (predictionList && predictionList.length > 0) {
            var list = predictionList.map(function (e) { return new SearchResult(e.description, e.description, 'location'); });
            // Find matching Recent Results
            var matchingRecentResults_1 = this.recentSearches.filter(function (r) { return r.text.includes(searchInput); });
            // Don't include duplicates
            list = list.filter(function (l) { return !matchingRecentResults_1.includes(l); });
            // Combine recent + results
            list = matchingRecentResults_1.concat(list.splice(0, Math.min(list.length, this._maxLocationResults - matchingRecentResults_1.length)));
            this.locationResults = list;
        }
        else
            this.locationResults = [];
        this.isSearching = false;
        this.cdRef.detectChanges();
    };
    Object.defineProperty(SearchBarComponent.prototype, "searchInput", {
        get: function () {
            return this.searchForm.controls.searchInput.value;
        },
        set: function (value) {
            this.searchForm.controls.searchInput.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    // Use this to keep track of when they've actually made a search request.
    // If they've made one, when they go to click the search bar again, we should clear the input
    SearchBarComponent.hasCompletedASearchRequest = false;
    return SearchBarComponent;
}(HasSubscriptions));
export { SearchBarComponent };
var SearchResult = /** @class */ (function () {
    function SearchResult(text, data, type) {
        this.text = text;
        this.data = data;
        this.type = type;
        this.text = text;
        this.data = data;
        this.type = type;
        this.id = '' + Date.now() + Math.floor(Math.random() * 1000);
    }
    return SearchResult;
}());
export { SearchResult };
